"use client";

import type { CohesionConfig } from "@2u-landing-pages/components/CohesionSnippet/CohesionSnippet";
import React, { createContext, useContext } from "react";

const CohesionConfigContext = createContext<CohesionConfig | undefined>(undefined);

export const CohesionConfigProvider: React.FC<{
  config: CohesionConfig;
  children: React.ReactNode;
}> = ({ config, children }) => (
  <CohesionConfigContext.Provider value={config}>{children}</CohesionConfigContext.Provider>
);

export const useCohesionConfigContext = (): CohesionConfig => {
  const config = useContext(CohesionConfigContext);
  if (!config) {
    return {
      monarch: { sourceId: "", clientToken: "" },
      make: { sourceKey: "", writeKey: "" },
    };
  }
  return config;
};
